// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pUXV35zvEe34m2VP6tXZ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  min-height: 48px;
  background: var(--vnsc-bg-secondary, #0f172a);
  border-bottom: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));
  padding: 0 16px;
  color: var(--vnsc-text-primary, #e2e8f0);
  font-family: var(--vnsc-font, sans-serif);
  gap: 12px;
  user-select: none;
  z-index: 100;
}

.NfnGSIRyyVlRaZxWz6QQ, .EvShhI3TTKEnzwmew9qj {
  display: flex;
  align-items: center;
  gap: 8px;
}

.hNP1XZklpxQV7n80dFAz {
  font-weight: 700;
  font-size: 15px;
  color: var(--vnsc-accent, #22d3ee);
  margin-right: 8px;
  white-space: nowrap;
}

.HTKJcruSPJcgchWa2ATS {
  width: 1px;
  height: 20px;
  background: var(--vnsc-border, rgba(148, 163, 184, 0.18));
  margin: 0 4px;
}

/* UIUX S2: focus status label — dot + highlighted pane title. */
._0RogHx3qC2O3uHAWMLff {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--vnsc-text-primary, #e2e8f0);
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));
  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));
  border-radius: 6px;
  padding: 3px 8px;
  white-space: nowrap;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ksxKrESX4S6O00zZ5Wf2 {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--vnsc-primary, #2962ff);
  flex-shrink: 0;
}

.OFyrBdHnNBFYmZQiaLC9 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--vnsc-text-secondary, #94a3b8);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.OFyrBdHnNBFYmZQiaLC9:hover {
  background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));
  color: var(--vnsc-text-primary, #e2e8f0);
}

.vtHZZlhK3mPenpNUz9yy {
  background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));
  color: var(--vnsc-accent, #22d3ee);
}

.ezHbQ09bqVjMx_Wed3VP {
  width: 32px;
  min-width: 32px;
  padding: 0;
  font-size: 16px;
}

.WPhMyxenzaPeo63BQgTO {
  position: relative;
}

.wWL56ISO_IiZpuJnFNLp {
  position: absolute;
  top: 38px;
  left: 0;
  background: var(--vnsc-bg-primary, #0a0e17);
  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));
  border-radius: 8px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 200;
  min-width: 160px;
}

.WkMCrbtHQa2i3UctgbmG {
  left: auto;
  right: 0;
}

.BGfA4ipy7HLkDJdgC4zE {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 4px;
}

.wqwuZ94VO8jZlU8Ryuuj {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 6px;
  border-radius: 6px;
  border: 1px dashed var(--vnsc-border, rgba(148, 163, 184, 0.18));
  cursor: pointer;
  transition: all 0.15s ease;
}

.wqwuZ94VO8jZlU8Ryuuj:hover {
  background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.05));
  border-color: var(--vnsc-accent, #22d3ee);
}

.zAsww66o4sqIpS5ppYgs {
  display: grid;
  width: 24px;
  height: 24px;
  gap: 2px;
  border: 1px solid var(--vnsc-text-muted, #64748b);
  padding: 2px;
  border-radius: 3px;
}

._a6nfNaAdoHtvXCT9v_y {
  background: var(--vnsc-text-muted, #64748b);
  border-radius: 1px;
}

.LRIEl1iSa0tjAeTHOQQe {
  border-color: var(--vnsc-accent, #22d3ee);
  background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.1));
}

.LRIEl1iSa0tjAeTHOQQe .zAsww66o4sqIpS5ppYgs {
  border-color: var(--vnsc-accent, #22d3ee);
}

.LRIEl1iSa0tjAeTHOQQe ._a6nfNaAdoHtvXCT9v_y {
  background: var(--vnsc-accent, #22d3ee);
}

.Wj43JkQt641j5m6RIFu2 {
  font-size: 11px;
  font-weight: 600;
  color: var(--vnsc-text-secondary, #94a3b8);
}

.LRIEl1iSa0tjAeTHOQQe .Wj43JkQt641j5m6RIFu2 {
  color: var(--vnsc-accent, #22d3ee);
}

.FjAIEQsgw87ZXZf1SChF {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  color: var(--vnsc-text-secondary, #94a3b8);
  font-size: 13px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.12s ease;
  white-space: nowrap;
}

.FjAIEQsgw87ZXZf1SChF:hover {
  background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.05));
  color: var(--vnsc-text-primary, #e2e8f0);
}

.FjAIEQsgw87ZXZf1SChF input {
  cursor: pointer;
  accent-color: var(--vnsc-accent, #22d3ee);
}

/* ── Mobile responsive (max-width: 768px) ──────────────────────────── */
@media (max-width: 768px) {
  .pUXV35zvEe34m2VP6tXZ {
    height: 40px;
    min-height: 40px;
    padding: 0 12px;
    gap: 6px;
  }
  
  .VpFi109gXE2ctT4BoP1d {
    font-weight: 800;
    font-size: 14px;
    color: var(--vnsc-accent, #22d3ee);
    margin-right: 6px;
    letter-spacing: 0.5px;
  }

  .rtefK_wih1Chw7I9KYQI {
    display: flex;
    align-items: center;
    margin-left: 4px;
  }

  .HMA7XL6Nc9UpzKp9Q4cm {
    background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));
    border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));
    border-radius: 6px;
    color: var(--vnsc-text-secondary, #94a3b8);
    font-size: 12px;
    font-weight: 600;
    padding: 3px 8px;
    height: 28px;
    outline: none;
    cursor: pointer;
  }

  .HMA7XL6Nc9UpzKp9Q4cm:focus {
    border-color: var(--vnsc-accent, #22d3ee);
    color: var(--vnsc-text-primary, #e2e8f0);
  }

  .mOajgFkDSWz5WNleO9rI {
    min-width: 260px;
    max-width: 90vw;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    padding: 12px;
    gap: 12px;
    background-color: var(--vnsc-bg-secondary, #0f172a);
    scrollbar-width: thin;
  }

  .Mmq8OV80FRhEKejtuPXn {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .sClJMkQKqwUDrSLHrNPd {
    font-size: 11px;
    font-weight: 700;
    color: var(--vnsc-text-muted, #64748b);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.1));
    padding-bottom: 4px;
    text-align: left;
  }

  .bgkhmxoOXoGz_zVdRDr6 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
  }

  .Twc0HYyAx7hgk07D2Ln3 {
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));
    border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));
    border-radius: 6px;
    color: var(--vnsc-text-secondary, #94a3b8);
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
  }

  .Twc0HYyAx7hgk07D2Ln3:hover {
    background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));
  }

  .f5zgOHgh2NZs3dsOBfDf {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .kK6vraM5cltf6GJCvpIw {
    display: flex;
    flex-direction: column;
    gap: 6px;
    border-top: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.15));
    padding-top: 8px;
    margin-top: 4px;
  }

  .he6koQfAc9R7_niErQfP {
    height: 32px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.1));
    border: 1px solid var(--vnsc-accent, #22d3ee);
    border-radius: 6px;
    color: var(--vnsc-accent, #22d3ee);
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
  }

  .he6koQfAc9R7_niErQfP:hover {
    background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.2));
  }

  .ykxJUfijBL9ihfJcAEPQ {
    background: var(--vnsc-accent, #22d3ee);
    color: var(--vnsc-bg-primary, #0a0e17);
  }

  .TQh3KuhUNgsiCjygyVkj {
    height: 1px;
    background: var(--vnsc-border, rgba(148, 163, 184, 0.15));
    margin: 4px 0;
  }

  .WBk4ggsQl4Smaf1fGcuw {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 4px;
  }

  .xK7e0EqLeYLPGF1d77R5 {
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));
    border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));
    border-radius: 6px;
    color: var(--vnsc-text-secondary, #94a3b8);
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
  }

  .xK7e0EqLeYLPGF1d77R5:hover {
    background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));
  }

  .DWzcihS_fpFcYZtbiBA0 {
    background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.15));
    border-color: var(--vnsc-accent, #22d3ee);
    color: var(--vnsc-accent, #22d3ee);
  }

  .DVNegbJgd65XuPZGbVs2 {
    width: 100%;
    height: 30px;
    background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));
    border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));
    border-radius: 6px;
    color: var(--vnsc-text-primary, #e2e8f0);
    font-size: 12px;
    padding: 0 8px;
    outline: none;
    cursor: pointer;
  }

  .NfnGSIRyyVlRaZxWz6QQ {
    flex: 1;
    min-width: 0;
  }

  .dQF7ryWFGnioZY8Txvip {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: 4px;
    min-width: 0;
  }

  .RWYC5qZpPgNfOHz_yX5U {
    font-weight: 700;
    font-size: 13px;
    color: var(--vnsc-text-primary, #e2e8f0);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80px;
  }

  .mn5yiMUCd8Jb4KOHNVR_ {
    font-size: 10px;
    font-weight: 600;
    color: var(--vnsc-text-muted, #64748b);
    background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));
    border-radius: 4px;
    padding: 1px 5px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .EvShhI3TTKEnzwmew9qj {
    gap: 4px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/widget/components/toolbar/MultiChartTopbar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,6CAA6C;EAC7C,sEAAsE;EACtE,eAAe;EACf,wCAAwC;EACxC,yCAAyC;EACzC,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yDAAyD;EACzD,aAAa;AACf;;AAEA,gEAAgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,2DAA2D;EAC3D,+DAA+D;EAC/D,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8DAA8D;EAC9D,wCAAwC;AAC1C;;AAEA;EACE,2DAA2D;EAC3D,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,2CAA2C;EAC3C,+DAA+D;EAC/D,kBAAkB;EAClB,+CAA+C;EAC/C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,gEAAgE;EAChE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,8DAA8D;EAC9D,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,iDAAiD;EACjD,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8DAA8D;EAC9D,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA,yEAAyE;AACzE;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kCAAkC;IAClC,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,2DAA2D;IAC3D,+DAA+D;IAC/D,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,yCAAyC;IACzC,wCAAwC;EAC1C;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,mDAAmD;IACnD,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,yBAAyB;IACzB,qBAAqB;IACrB,qEAAqE;IACrE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2DAA2D;IAC3D,+DAA+D;IAC/D,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,8DAA8D;EAChE;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mEAAmE;IACnE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,0DAA0D;IAC1D,6CAA6C;IAC7C,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,0DAA0D;EAC5D;;EAEA;IACE,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;IACE,WAAW;IACX,yDAAyD;IACzD,aAAa;EACf;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2DAA2D;IAC3D,+DAA+D;IAC/D,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,8DAA8D;EAChE;;EAEA;IACE,2DAA2D;IAC3D,yCAAyC;IACzC,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,2DAA2D;IAC3D,+DAA+D;IAC/D,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,cAAc;IACd,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,2DAA2D;IAC3D,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":[".topbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  height: 48px;\r\n  min-height: 48px;\r\n  background: var(--vnsc-bg-secondary, #0f172a);\r\n  border-bottom: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));\r\n  padding: 0 16px;\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n  font-family: var(--vnsc-font, sans-serif);\r\n  gap: 12px;\r\n  user-select: none;\r\n  z-index: 100;\r\n}\r\n\r\n.leftSection, .rightSection {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.title {\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  color: var(--vnsc-accent, #22d3ee);\r\n  margin-right: 8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.divider {\r\n  width: 1px;\r\n  height: 20px;\r\n  background: var(--vnsc-border, rgba(148, 163, 184, 0.18));\r\n  margin: 0 4px;\r\n}\r\n\r\n/* UIUX S2: focus status label — dot + highlighted pane title. */\r\n.focusLabel {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));\r\n  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));\r\n  border-radius: 6px;\r\n  padding: 3px 8px;\r\n  white-space: nowrap;\r\n  max-width: 260px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.focusDot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: var(--vnsc-primary, #2962ff);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 32px;\r\n  padding: 0 10px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.btn:hover {\r\n  background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n}\r\n\r\n.btnActive {\r\n  background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.12));\r\n  color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.iconBtn {\r\n  width: 32px;\r\n  min-width: 32px;\r\n  padding: 0;\r\n  font-size: 16px;\r\n}\r\n\r\n.dropdown {\r\n  position: relative;\r\n}\r\n\r\n.dropdownMenu {\r\n  position: absolute;\r\n  top: 38px;\r\n  left: 0;\r\n  background: var(--vnsc-bg-primary, #0a0e17);\r\n  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));\r\n  border-radius: 8px;\r\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5);\r\n  padding: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  z-index: 200;\r\n  min-width: 160px;\r\n}\r\n\r\n.dropdownMenuRight {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n\r\n.gridSelector {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 8px;\r\n  padding: 4px;\r\n}\r\n\r\n.gridItem {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 6px;\r\n  border-radius: 6px;\r\n  border: 1px dashed var(--vnsc-border, rgba(148, 163, 184, 0.18));\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.gridItem:hover {\r\n  background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.05));\r\n  border-color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.gridIcon {\r\n  display: grid;\r\n  width: 24px;\r\n  height: 24px;\r\n  gap: 2px;\r\n  border: 1px solid var(--vnsc-text-muted, #64748b);\r\n  padding: 2px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.gridCell {\r\n  background: var(--vnsc-text-muted, #64748b);\r\n  border-radius: 1px;\r\n}\r\n\r\n.gridItemActive {\r\n  border-color: var(--vnsc-accent, #22d3ee);\r\n  background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.1));\r\n}\r\n\r\n.gridItemActive .gridIcon {\r\n  border-color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.gridItemActive .gridCell {\r\n  background: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.gridLabel {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n}\r\n\r\n.gridItemActive .gridLabel {\r\n  color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n.syncOption {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 8px;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: all 0.12s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.syncOption:hover {\r\n  background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.05));\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n}\r\n\r\n.syncOption input {\r\n  cursor: pointer;\r\n  accent-color: var(--vnsc-accent, #22d3ee);\r\n}\r\n\r\n/* ── Mobile responsive (max-width: 768px) ──────────────────────────── */\r\n@media (max-width: 768px) {\r\n  .topbar {\r\n    height: 40px;\r\n    min-height: 40px;\r\n    padding: 0 12px;\r\n    gap: 6px;\r\n  }\r\n  \r\n  .titleMobile {\r\n    font-weight: 800;\r\n    font-size: 14px;\r\n    color: var(--vnsc-accent, #22d3ee);\r\n    margin-right: 6px;\r\n    letter-spacing: 0.5px;\r\n  }\r\n\r\n  .timeframeSelectMobile {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-left: 4px;\r\n  }\r\n\r\n  .combobox {\r\n    background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));\r\n    border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));\r\n    border-radius: 6px;\r\n    color: var(--vnsc-text-secondary, #94a3b8);\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    padding: 3px 8px;\r\n    height: 28px;\r\n    outline: none;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .combobox:focus {\r\n    border-color: var(--vnsc-accent, #22d3ee);\r\n    color: var(--vnsc-text-primary, #e2e8f0);\r\n  }\r\n\r\n  .mobileSystemMenu {\r\n    min-width: 260px;\r\n    max-width: 90vw;\r\n    max-height: calc(100vh - 100px);\r\n    overflow-y: auto;\r\n    padding: 12px;\r\n    gap: 12px;\r\n    background-color: var(--vnsc-bg-secondary, #0f172a);\r\n    scrollbar-width: thin;\r\n  }\r\n\r\n  .menuSection {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n  }\r\n\r\n  .menuSectionTitle {\r\n    font-size: 11px;\r\n    font-weight: 700;\r\n    color: var(--vnsc-text-muted, #64748b);\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n    border-bottom: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.1));\r\n    padding-bottom: 4px;\r\n    text-align: left;\r\n  }\r\n\r\n  .gridSelectorCompact {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 6px;\r\n  }\r\n\r\n  .gridItemCompact {\r\n    height: 28px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));\r\n    border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));\r\n    border-radius: 6px;\r\n    color: var(--vnsc-text-secondary, #94a3b8);\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .gridItemCompact:hover {\r\n    background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));\r\n  }\r\n\r\n  .syncOptionsCompact {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2px;\r\n  }\r\n\r\n  .menuActions {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n    border-top: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.15));\r\n    padding-top: 8px;\r\n    margin-top: 4px;\r\n  }\r\n\r\n  .menuActionBtn {\r\n    height: 32px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 10px;\r\n    background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.1));\r\n    border: 1px solid var(--vnsc-accent, #22d3ee);\r\n    border-radius: 6px;\r\n    color: var(--vnsc-accent, #22d3ee);\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .menuActionBtn:hover {\r\n    background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.2));\r\n  }\r\n\r\n  .menuActionBtnActive {\r\n    background: var(--vnsc-accent, #22d3ee);\r\n    color: var(--vnsc-bg-primary, #0a0e17);\r\n  }\r\n\r\n  .menuDivider {\r\n    height: 1px;\r\n    background: var(--vnsc-border, rgba(148, 163, 184, 0.15));\r\n    margin: 4px 0;\r\n  }\r\n\r\n  .timeframeGridMobile {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    gap: 4px;\r\n  }\r\n\r\n  .timeframeChip {\r\n    height: 28px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));\r\n    border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));\r\n    border-radius: 6px;\r\n    color: var(--vnsc-text-secondary, #94a3b8);\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .timeframeChip:hover {\r\n    background: var(--vnsc-bg-tertiary, rgba(255, 255, 255, 0.06));\r\n  }\r\n\r\n  .timeframeChipActive {\r\n    background: var(--vnsc-accent-bg, rgba(34, 211, 238, 0.15));\r\n    border-color: var(--vnsc-accent, #22d3ee);\r\n    color: var(--vnsc-accent, #22d3ee);\r\n  }\r\n\r\n  .mobileSelect {\r\n    width: 100%;\r\n    height: 30px;\r\n    background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));\r\n    border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));\r\n    border-radius: 6px;\r\n    color: var(--vnsc-text-primary, #e2e8f0);\r\n    font-size: 12px;\r\n    padding: 0 8px;\r\n    outline: none;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .leftSection {\r\n    flex: 1;\r\n    min-width: 0;\r\n  }\r\n\r\n  .mobileActiveInfo {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    margin-left: 4px;\r\n    min-width: 0;\r\n  }\r\n\r\n  .mobileSymbol {\r\n    font-weight: 700;\r\n    font-size: 13px;\r\n    color: var(--vnsc-text-primary, #e2e8f0);\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 80px;\r\n  }\r\n\r\n  .mobileTimeframeMirror {\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n    color: var(--vnsc-text-muted, #64748b);\r\n    background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));\r\n    border-radius: 4px;\r\n    padding: 1px 5px;\r\n    white-space: nowrap;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .rightSection {\r\n    gap: 4px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topbar": `pUXV35zvEe34m2VP6tXZ`,
	"leftSection": `NfnGSIRyyVlRaZxWz6QQ`,
	"rightSection": `EvShhI3TTKEnzwmew9qj`,
	"title": `hNP1XZklpxQV7n80dFAz`,
	"divider": `HTKJcruSPJcgchWa2ATS`,
	"focusLabel": `_0RogHx3qC2O3uHAWMLff`,
	"focusDot": `ksxKrESX4S6O00zZ5Wf2`,
	"btn": `OFyrBdHnNBFYmZQiaLC9`,
	"btnActive": `vtHZZlhK3mPenpNUz9yy`,
	"iconBtn": `ezHbQ09bqVjMx_Wed3VP`,
	"dropdown": `WPhMyxenzaPeo63BQgTO`,
	"dropdownMenu": `wWL56ISO_IiZpuJnFNLp`,
	"dropdownMenuRight": `WkMCrbtHQa2i3UctgbmG`,
	"gridSelector": `BGfA4ipy7HLkDJdgC4zE`,
	"gridItem": `wqwuZ94VO8jZlU8Ryuuj`,
	"gridIcon": `zAsww66o4sqIpS5ppYgs`,
	"gridCell": `_a6nfNaAdoHtvXCT9v_y`,
	"gridItemActive": `LRIEl1iSa0tjAeTHOQQe`,
	"gridLabel": `Wj43JkQt641j5m6RIFu2`,
	"syncOption": `FjAIEQsgw87ZXZf1SChF`,
	"titleMobile": `VpFi109gXE2ctT4BoP1d`,
	"timeframeSelectMobile": `rtefK_wih1Chw7I9KYQI`,
	"combobox": `HMA7XL6Nc9UpzKp9Q4cm`,
	"mobileSystemMenu": `mOajgFkDSWz5WNleO9rI`,
	"menuSection": `Mmq8OV80FRhEKejtuPXn`,
	"menuSectionTitle": `sClJMkQKqwUDrSLHrNPd`,
	"gridSelectorCompact": `bgkhmxoOXoGz_zVdRDr6`,
	"gridItemCompact": `Twc0HYyAx7hgk07D2Ln3`,
	"syncOptionsCompact": `f5zgOHgh2NZs3dsOBfDf`,
	"menuActions": `kK6vraM5cltf6GJCvpIw`,
	"menuActionBtn": `he6koQfAc9R7_niErQfP`,
	"menuActionBtnActive": `ykxJUfijBL9ihfJcAEPQ`,
	"menuDivider": `TQh3KuhUNgsiCjygyVkj`,
	"timeframeGridMobile": `WBk4ggsQl4Smaf1fGcuw`,
	"timeframeChip": `xK7e0EqLeYLPGF1d77R5`,
	"timeframeChipActive": `DWzcihS_fpFcYZtbiBA0`,
	"mobileSelect": `DVNegbJgd65XuPZGbVs2`,
	"mobileActiveInfo": `dQF7ryWFGnioZY8Txvip`,
	"mobileSymbol": `RWYC5qZpPgNfOHz_yX5U`,
	"mobileTimeframeMirror": `mn5yiMUCd8Jb4KOHNVR_`
};
export default ___CSS_LOADER_EXPORT___;
